import React from 'react';
import FullScreenDataContainer
  from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import { useCollectionStateContext } from 'Context/CollectionStateContext';
import NullComponent from 'Components/UI/NullComponent';
import Content from './Content';

const FreemiumContainer = () => {
  const { isInitializing, loadingError, collection } = useCollectionStateContext();

  return (
    <FullScreenDataContainer
      component={Content}
      componentProps={{
        collection,
      }}
      skeleton={NullComponent}
      loadingError={loadingError}
      loading={isInitializing}
    />
  );
};

export default FreemiumContainer;
